import {
  AdditionalInfoReport,
  ChartData,
  TopVisitData,
  TopMenuData,
  Export,
  MonthlyAccessChartsData,
} from '@/domain/entities/AdditionalInfoReport'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class AdditionalInfoReportDataMapper extends BaseResponseMapper {
  public convertAdditionalInfoReportFromApi(
    result: AxiosResponse<any>
  ): AdditionalInfoReport {
    const { data } = result
    return new AdditionalInfoReport(
      data.success,
      data.message,
      data.data.top_menu.items.map(
        (menu) =>
          new TopMenuData(menu.id, menu.name, menu.key, menu.value, menu.color)
      ),
      data.data.charts.items.map(
        (chart) => new ChartData(chart.period, chart.total)
      ),
      data.data.monthly_access_charts
        ? data.data.monthly_access_charts.items.map(
            (val) =>
              new MonthlyAccessChartsData(
                val.month,
                val.percentage,
                val.total_user_access,
                val.total_user_visit
              )
          )
        : [],
      data.data.top_visit.items.map(
        (user) =>
          new TopVisitData(
            user.id,
            user.file_code,
            user.title,
            user.created_date,
            user.total_user,
            user.total_visit
          )
      )
    )
  }
  public convertExportFileFromAPi(result: AxiosResponse<any>): Export {
    const { data } = result
    return new Export(data.success, data.message, data.data)
  }
}
